import { render, staticRenderFns } from "./Refuge.vue?vue&type=template&id=56c0b68f"
import script from "./Refuge.vue?vue&type=script&lang=js"
export * from "./Refuge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports